import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const PreventNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Push initial state
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Prevent backward/forward navigation
      navigate(location.pathname, { replace: true });
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, location]);

  return null;
};
export default PreventNavigation;
